import { useShallow } from 'zustand/react/shallow';

import { useRegionStore } from '@packages/stores';
import { getAge } from '@packages/utils';

import { useGuestStore } from '@store';

export const useTravellersText = () => {
  const country = useRegionStore(state => state.region?.country);
  return useGuestStore(
    useShallow(state => {
      const primaryTraveller = {
        name: `${state.guest?.firstName} ${state.guest?.lastName}`,
        age: getAge(state.guest?.dob ?? '', country),
        travellerId: state.guest?.userId,
      };
      const secondaryTravellers =
        state.guest?.secondaryTravellers?.map(traveller => ({
          name: `${traveller.firstName} ${traveller.lastName}`,
          age: getAge(traveller.dob ?? '', country),
          travellerId: traveller.sortKey,
        })) ?? [];

      return [primaryTraveller, ...secondaryTravellers];
    }),
  );
};
